import React from 'react';
import { Colors, handleGetAgingDate, Images, PermissionsList, RolePermission } from 'utils';
import {
  DateRow,
  PriceRow,
  TextRow,
  TypeRow,
  HyperLinkRow,
  EditableTableInputRow,
  EditableTableSelectRow,
  TextToolTip,
} from 'components';
import { LoadService } from 'fragments/loads/load.service';
import { Checkbox } from '@material-ui/core';
import { SettingsPendingPayBatchesDetails } from './settingsPendingPayBatchesDetails';
import { pmtTerm, pmtTermList } from 'fragments';
import { PayableNoteCell } from './payableNoteCell';


export const tabEnums = {
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  PAID: 'PAID',
};

export const tabParams = [
  { name: 'Open', type: tabEnums?.OPEN },
  { name: 'Pending', type: tabEnums?.PENDING },
  { name: 'Approved', type: tabEnums?.APPROVED },
  { name: 'Paid', type: tabEnums?.PAID },
];

export const batchStatusesEnum = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  APPROVED: 'APPROVED',
};

export const payableNotesEnum = {
  NONE: 'NONE',
  LOW: 'LOW',
  HIGH: 'HIGH',
};

export const PmtMethodPayablesEnum = {
  ACH: 'ACH',
  WIRE: 'WIRE',
  CHECK: 'CHECK',
  RTP: 'RTP',
  ZELLE: 'ZELLE',
  EFS_CODE: 'EFS_CODE',
  EFS_CARD: 'EFS_CARD',
  MISC: 'MISC',
  // FACTORED: 'FACTORED',
};

export const pmtMethodPayables = {
  ACH: 'ACH',
  WIRE: 'Wire',
  CHECK: 'Check',
  RTP: 'RTP',
  ZELLE: 'Zelle',
  EFS: 'EFS',
  EFS_CODE: 'EFS Code',
  EFS_CARD: 'EFS Card',
  MISC: 'Misc',
  FACTORED: 'Factored',
};

export const pmtMethodPayablesList = [
  {
    id: PmtMethodPayablesEnum.ACH,
    name: pmtMethodPayables.ACH,
  },

  {
    id: PmtMethodPayablesEnum.WIRE,
    name: pmtMethodPayables.WIRE,
  },

  {
    id: PmtMethodPayablesEnum.CHECK,
    name: pmtMethodPayables.CHECK,
  },

  {
    id: PmtMethodPayablesEnum.RTP,
    name: pmtMethodPayables.RTP,
  },

  {
    id: PmtMethodPayablesEnum.ZELLE,
    name: pmtMethodPayables.ZELLE,
  },

  {
    id: PmtMethodPayablesEnum.EFS_CODE,
    name: pmtMethodPayables.EFS_CODE,
  },

  {
    id: PmtMethodPayablesEnum.EFS_CARD,
    name: pmtMethodPayables.EFS_CARD,
  },

  {
    id: PmtMethodPayablesEnum.MISC,
    name: pmtMethodPayables.MISC,
  },
];

export const payableNotesPriorities = [payableNotesEnum.HIGH, payableNotesEnum.LOW, payableNotesEnum.NONE];

export const payableNotesColors = {
  NONE: {
    circleColor: '#9C9EA9',
    borderColor: '#E6ECF3',
    backgroundColor: '#F7F9FC',
    filter: 'brightness(0) saturate(100%) invert(66%) sepia(4%) saturate(542%) hue-rotate(194deg) brightness(95%) contrast(90%)',
  },
  LOW: {
    circleColor: '#FDC517',
    borderColor: '#FEEAAB',
    backgroundColor: '#FFF7DE',
    filter: 'brightness(0) saturate(100%) invert(81%) sepia(52%) saturate(872%) hue-rotate(343deg) brightness(100%) contrast(99%)',
  },
  HIGH: {
    circleColor: '#E63946',
    borderColor: '#FDCED7',
    backgroundColor: '#FEEBF0',
    filter: 'brightness(0) saturate(100%) invert(29%) sepia(99%) saturate(1814%) hue-rotate(335deg) brightness(93%) contrast(94%)',
  },
};

export const settings = [
  {
    id: 1,
    Image: Images.arrowRightWithBorder,
    text: 'Move to',
  },

  {
    id: 2,
    Image: Images.plusWithBorder,
    text: 'Create New Batch',
  },

  {
    id: 3,
    Image: Images.arrowLeftWithBorder,
    text: 'Back to Open Payables',
  },

  // {
  //   id: 4',
  //   Image: Images.download2,
  //   text: 'Download Remittance',
  // },
];

export const payablesHead = ({ list, currentList, handleSelectAll }) => [
  {
    renderView:
      <Checkbox
        style={{ padding: '0 0 0 4px', color: Colors.ThemeBlue }}
        onChange={handleSelectAll}
        checked={!!list?.length && list?.length === currentList?.length}
      />,
  },
  // { name: '', title: ' ', notSearch: true, custom: false, width: '0' },
  { name: 'loadId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
  { name: 'Carrier', searchKey: 'CARRIER', title: 'Vendor', custom: false },
  { name: 'payable', nameRow: 'payeeName', title: 'Payee', custom: false, width: 156 },
  {
    name: 'payable.pmtMethod', title: 'Method', custom: true, width: 119,
    // filterList: [
    //     {name: 'All', id: ''},
    //     {name: 'Check', id: 'CHECK'},
    //     {name: 'Ach', id: 'ACH'},
    //     {name: 'Efs', id: 'EFS'},
    // ]
  },
  {
    name: 'payable.pmtTerm', title: 'Term', custom: true, width: 150,
    filterList: [
      { name: 'All', id: '' },
      ...pmtTermList,
    ],
    // [
    //   {name: 'All', id: ''},
    //   {name: 'Custom Quick Pay', id: 'CHECK'},
    //   {name: '30 Day', id: 'ACH'},
    //   {name: 'Quick Pay', id: 'EFS'},
    // ]
  },
  {
    title: 'Aging', name: 'agingBucket',
    filterList: [
      { name: 'All', id: '' },
      { name: '0+', id: 'CURRENT' },
      { name: '30+', id: 'DUE_NOW' },
      { name: '60+', id: 'PAST_DUE' },
      { name: '90+', id: 'URGENT' },
    ],
  },
  { name: 'lastInvoiceDate', nameRow: 'invoiceDate', title: 'Invoice Date', custom: true, type: 'date' },
  { name: 'payable.dueDate', nameRow: 'dueDate', title: 'Due Date', custom: true, type: 'date' },
  { name: 'payable.balance', title: 'Final Amount', icon: 'date', smallSize: 6, type: 'date', custom: true },
  { name: 'pNotes', title: 'Note', custom: false, width: 386 },
  { name: ' ', title: 'Actions', custom: false, disabled: true },
];

export const payablesBody = ({
                               handleSelect,
                               currentList,
                               clickRequestCorrection,
                               factoringsList,
                               changeRowItem,
                               handleAddNote,
                             }) => [
  {
    rowText: (item) =>
      <Checkbox
        style={{ padding: '0 0 0 4px', color: Colors.ThemeBlue }} name={item?.id}
        checked={currentList && !!currentList.find((i) => i?.id === item?.id)}
        onClick={(e) => handleSelect(e, item)}
      />,
    notClickable: true,
  },
  {
    rowText: (item) => <TextToolTip text={item?.displayId} content={item?.displayId} />,
    // <LinkRow loadId={item?.id} id={item?.displayId} />
  },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.carrier?.name}
      href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
      checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
    />,
    // <TextRow name={item?.carrier?.name} textWidth={12} />,
  },
  {
    rowText: (item) => {
      return (
        <EditableTableSelectRow
          firstListTitle="Choose Vendor"
          secondListTitle="Choose Factoring"
          handleBlur={(value) => changeRowItem(value, item?.id, 'payee')}
          currentItem={{
            id: item?.payable?.payeeId,
            name: item?.payable?.payeeName,
          }}
          list={item?.carrier?.name ? [{
            id: item?.carrier?.id,
            name: item?.carrier?.name,
          }] : []}
          secondList={factoringsList || []}
        />
      );
    },
    padding: '0px',
  },

  {
    rowText: (item) => {
      // return <TypeRow text={item?.payable?.pmtMethod ? item?.payable?.pmtMethod : ''} />;

      return (
        <EditableTableSelectRow
          firstListTitle="Choose Method"
          handleBlur={(value) => changeRowItem(value, item?.id, 'method')}
          currentItem={{
            id: item?.payable?.pmtMethod,
            name: pmtMethodPayables?.[item?.payable?.pmtMethod],
          }}
          list={pmtMethodPayablesList}
        />
      );
    },
    padding: '0px',
  },

  {
    rowText: (item) => {
      return (
        <EditableTableSelectRow
          firstListTitle="Choose Term"
          handleBlur={(value) => changeRowItem(value, item?.id, 'term')}
          currentItem={{
            id: item?.payable?.pmtTerm,
            name: pmtTerm?.[item?.payable?.pmtTerm],
          }}
          list={pmtTermList}
        />
      );
    },
    padding: '0px',
  },
  // {rowText: (item) => <div>{handleGetDate(item?.payable?.submittedAt)}</div>, type: 'returnColor'},

  // handleGetDate(item?.payable?.verifiedDate)
  { rowText: (item) => <div>{handleGetAgingDate(item?.payable?.verifiedDate)}</div>, type: 'returnColor' },

  { rowText: (item) => <DateRow date={item?.bill?.lastInvoiceDate} /> },
  { rowText: (item) => <DateRow date={item?.payable?.dueDate} /> },
  { rowText: (item) => <PriceRow info={LoadService.getPayableBalance(item?.payable)} /> },
  { rowText: (item) => <PayableNoteCell load={item} handleAddNote={handleAddNote} />, notClickable: true },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.PAYABLE_CORRECTION?.code]) &&
  {
    rowText: (item) =>
      <button
        className={'request-correction'}
        onClick={() => clickRequestCorrection(item)}
      >
        <TextToolTip
          arrow
          showTooltip
          placement="right"
          text={<img src={Images.info2} alt="info" />}
          content={'Request Correction'}
        />
      </button>,
    notClickable: true,
  },
];

export const pendingPayableBatchesHead = [
  { name: 'displayIdString', searchKey: 'displayIdString', title: 'Batch ID', custom: true, width: 160 },
  { name: 'name', title: 'Batch  Name', searchKey: 'name', custom: true, width: 407 },
  { name: 'payoutDate', title: 'Payout Date', icon: 'date', type: 'date', custom: true },
  { name: 'amount', title: 'Total', searchKey: 'amount', custom: true },
  { name: '', title: 'Actions', custom: false, notSearch: true, width: 100 },
];


export const pendingPayableBatchesBody = (
  {
    handleApprove,
    handleDelete,
    changeBatchName,
    loadingLoads,
    isOpeningAccordionId,
    calculateLoadTotals,
  }) => [
  { rowText: (item) => <TextRow name={item?.displayIdString} /> },
  {
    rowText: (item) =>
      <EditableTableInputRow
        handleBlur={(value) => changeBatchName(item?.id, value)}
        text={item?.name} content={item?.name}
      />,
    padding: '0px',
  },
  { rowText: (item) => <DateRow date={item?.payoutDate} /> },
  {
    rowText: (item) => <PriceRow
      info={(isOpeningAccordionId === item?.id && !loadingLoads?.length) ? calculateLoadTotals() : item?.amount} />,
  },
  {
    rowText: (item) =>
      <div className="flex-align-center" style={{ justifyContent: 'flex-end', gap: 8 }}>
        {(RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.APPROVE_BATCH?.code]) && !!item?.loads?.length) &&
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleApprove(item);
            }
            }
            className="reset-btn align-justify-center"
            style={{
              textTransform: 'capitalize',
              background: Colors.ThemeGreen,
              color: Colors.TextWhite,
              borderRadius: '32px',
              fontSize: '14px',
              fontWeight: '600',
              padding: '2px 24px 4px',
              boxShadow: '0px 0px 6px 0px rgba(52, 122, 240, 0.30)',
            }}
          >
            Approve
          </button>
        }
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(item);
          }
          }
          className="reset-btn align-justify-center"
          style={{
            width: '24px',
            height: '24px',
            padding: '4px 5px',
          }}
        >
          <img
            src={Images.trashIcon}
            alt="trash"
            style={{
              width: '100%',
              height: '100%',
              filter: `brightness(0) saturate(100%) invert(31%) sepia(71%) saturate(1492%) hue-rotate(326deg) brightness(93%) contrast(100%)`,
            }}
          />
        </button>
      </div>,
  },
];

export const pendingPayableBatchesDetailsHead = ({ list, currentList, handleSelectAll }) => [
  {
    renderView:
      <Checkbox
        style={{ padding: '0 0 0 4px', color: Colors.ThemeBlue }}
        onChange={handleSelectAll}
        checked={!!list?.length && list?.length === currentList?.length}
      />,
  },
  { name: 'displayId', title: 'Load ID', custom: false },
  { name: 'carrier', nameRow: 'name', title: 'Vendor', custom: false },
  { name: 'payable', nameRow: 'payeeName', title: 'Payee', custom: false },
  { name: '', nameRow: 'pmtMethod', title: 'Method', custom: false },
  { name: '', nameRow: 'pmtTerm', title: 'Term', custom: false },
  { name: '', title: 'Aging', custom: false },
  { name: '', nameRow: 'invoiceDate', title: 'Invoice Date', custom: false, type: 'date' },
  { name: '', nameRow: 'dueDate', title: 'Due Date', custom: false, type: 'date' },
  { name: '', title: 'Final Amount', icon: 'date', smallSize: 6, type: 'date', custom: false },
  { name: '', title: 'Note', custom: false, width: 386 },
  { name: '', title: 'Actions', custom: false, notSearch: true },
];

export const pendingPayableBatchesDetailsBody = (
  {
    batch,
    batchesList,
    handleSelect,
    currentList,
    clickRequestCorrection,
    afterMoveSuccess,
    handleAddNote,
  }) => [
  {
    rowText: (item) =>
      <Checkbox
        style={{ padding: '0 0 0 4px', color: Colors.ThemeBlue }} name={item?.id}
        checked={currentList && !!currentList.find((i) => i?.id === item?.id)}
        onClick={(e) => handleSelect(e, item)}
      />,
    notClickable: true,
  },
  {
    rowText: (item) => <div>{item?.displayId}</div>,
    // <LinkRow loadId={item?.id} id={item?.displayId} />
  },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.carrier?.name}
      href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
      checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
    />,
    // <TextRow name={item?.carrier?.name} textWidth={12} />,
  },
  { rowText: (item) => <TextRow name={item?.payable?.payeeName} textWidth={12} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtMethod ? item?.payable?.pmtMethod : ''} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtTerm ? item?.payable?.pmtTerm : ''} /> },
  // {rowText: (item) => <div>{handleGetDate(item?.payable?.submittedAt)}</div>, type: 'returnColor'},
  { rowText: (item) => <div>{handleGetAgingDate(item?.payable?.verifiedDate)}</div>, type: 'returnColor' },
  { rowText: (item) => <DateRow date={item?.bill?.lastInvoiceDate} /> },
  { rowText: (item) => <DateRow date={item?.payable?.dueDate} /> },
  { rowText: (item) => <PriceRow info={LoadService.getPayableBalance(item?.payable)} /> },
  { rowText: (item) => <PayableNoteCell load={item} handleAddNote={handleAddNote} />, notClickable: true },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.PAYABLE_CORRECTION?.code]) &&
  // {
  //   rowText: (item) =>
  //     <div className='align-justify-center' style={{ gap: 10 }}>
  //       <button
  //         className={'request-correction'}
  //         onClick={() => clickRequestCorrection(item)}
  //       >
  //         Request Corrections
  //       </button>
  //
  //       <SettingsPendingPayBatchesDetails
  //         batch={batch?.id}
  //         batchesList={batchesList}
  //         load={item}
  //         afterMoveSuccess={afterMoveSuccess}
  //       />
  //     </div>,
  //   notClickable: true,
  // },

  {
    rowText: (item) =>
      <div className="align-justify-center" style={{ gap: 10 }}>
        <button
          className={'request-correction'}
          onClick={() => clickRequestCorrection(item)}
        >
          <TextToolTip
            arrow
            showTooltip
            placement="right"
            text={<img src={Images.info2} alt="info" />}
            content={'Request Correction'}
          />
        </button>

        <SettingsPendingPayBatchesDetails
          batch={batch?.id}
          batchesList={batchesList}
          load={item}
          afterMoveSuccess={afterMoveSuccess}
        />
      </div>,
    notClickable: true,
  },
];

export const approvedPayableBatchesHead = [
  { name: 'displayIdString', searchKey: 'displayIdString', title: 'Batch ID', custom: true, width: 160 },
  { name: 'name', title: 'Batch  Name', searchKey: 'name', custom: true, width: 407 },
  { name: 'payoutDate', title: 'Payout Date', icon: 'date', type: 'date', custom: true },
  { name: 'amount', title: 'Total', searchKey: 'amount', custom: true },
  { name: '', title: 'Actions', custom: false, notSearch: true, width: 100 },
];


export const approvedPayableBatchesBody = (
  {
    changeBatchName,
    handlePay,
    handleBeckToPending,
    loadingLoads,
    isOpeningAccordionId,
    calculateLoadTotals,
  }) => [
  { rowText: (item) => <TextRow name={item?.displayIdString} /> },
  {
    rowText: (item) =>
      <EditableTableInputRow
        handleBlur={(value) => changeBatchName(item?.id, value)}
        text={item?.name} content={item?.name}
      />,
    padding: '0px',
  },
  { rowText: (item) => <DateRow date={item?.payoutDate} /> },
  {
    rowText: (item) => <PriceRow
      info={(isOpeningAccordionId === item?.id && !loadingLoads?.length) ? calculateLoadTotals() : item?.amount} />,
  },
  {
    rowText: (item) =>
      <div className="flex-align-center" style={{ justifyContent: 'flex-end', gap: 8 }}>
        {(RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_CARRIER_PAYMENT?.code]) && !!item?.loads?.length) &&
          <button
            onClick={(e) => {
              e.stopPropagation();
              handlePay(item);
            }
            }
            className="reset-btn align-justify-center"
            style={{
              height: '24px',
              textTransform: 'capitalize',
              background: Colors.ThemeGreen,
              color: Colors.TextWhite,
              borderRadius: '32px',
              fontSize: '14px',
              fontWeight: '600',
              padding: '2px 24px 4px',
              boxShadow: '0px 0px 6px 0px rgba(52, 122, 240, 0.30)',
            }}
          >
            Pay
          </button>
        }

        {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.APPROVE_BATCH?.code]) &&
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleBeckToPending(item);
            }
            }
            className="request-correction-secondary"
          >
            Back to Pending
          </button>
        }
      </div>,
  },
];

export const approvedPayableBatchesDetailsHead = () => [
  { name: 'displayId', title: 'Load ID', custom: false },
  { name: 'carrier', nameRow: 'name', title: 'Vendor', custom: false },
  { name: 'payable', nameRow: 'payeeName', title: 'Payee', custom: false },
  { name: '', nameRow: 'pmtMethod', title: 'Method', custom: false },
  { name: '', nameRow: 'pmtTerm', title: 'Term', custom: false },
  { name: '', title: 'Aging', custom: false },
  { name: '', nameRow: 'invoiceDate', title: 'Invoice Date', custom: false, type: 'date' },
  { name: '', nameRow: 'dueDate', title: 'Due Date', custom: false, type: 'date' },
  { name: '', title: 'Final Amount', icon: 'date', smallSize: 6, type: 'date', custom: false },
  { name: '', title: 'Note', custom: false, width: 386 },
  { name: '', title: 'Actions', custom: false, notSearch: true },
];

export const approvedPayableBatchesDetailsBody = (
  {
    clickRequestCorrection,
    handleAddNote,
  }) => [
  {
    rowText: (item) => <TextToolTip text={item?.displayId} content={item?.displayId} />,
  },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.carrier?.name}
      href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
      checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
    />,
    // <TextRow name={item?.carrier?.name} textWidth={12} />,
  },
  { rowText: (item) => <TextRow name={item?.payable?.payeeName} textWidth={12} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtMethod ? item?.payable?.pmtMethod : ''} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtTerm ? item?.payable?.pmtTerm : ''} /> },
  // {rowText: (item) => <div>{handleGetDate(item?.payable?.submittedAt)}</div>, type: 'returnColor'},
  { rowText: (item) => <div>{handleGetAgingDate(item?.payable?.verifiedDate)}</div>, type: 'returnColor' },
  { rowText: (item) => <DateRow date={item?.bill?.lastInvoiceDate} /> },
  { rowText: (item) => <DateRow date={item?.payable?.dueDate} /> },
  { rowText: (item) => <PriceRow info={LoadService.getPayableBalance(item?.payable)} /> },
  { rowText: (item) => <PayableNoteCell load={item} handleAddNote={handleAddNote} />, notClickable: true },
  RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.PAYABLE_CORRECTION?.code]) &&
  {
    rowText: (item) =>
      <div className="align-justify-center" style={{ gap: 10 }}>
        <button
          className={'request-correction'}
          onClick={() => clickRequestCorrection(item)}
        >
          <TextToolTip
            arrow
            showTooltip
            placement="right"
            text={<img src={Images.info2} alt="info" />}
            content={'Request Correction'}
          />
        </button>
      </div>,
    notClickable: true,
  },
];


export const paidPayableBatchesHead = [
  { name: 'displayIdString', searchKey: 'displayIdString', title: 'Batch ID', custom: true, width: 160 },
  { name: 'name', title: 'Batch  Name', searchKey: 'name', custom: true, width: 407 },
  { name: 'payoutDate', title: 'Payout Date', icon: 'date', type: 'date', custom: true },
  { name: 'amount', title: 'Total', searchKey: 'amount', custom: true },
  // { name: '', title: 'Actions', custom: false, notSearch: true, width: 100 },
];


export const paidPayableBatchesBody = ({ changeBatchName }) => [
  { rowText: (item) => <TextRow name={item?.displayIdString} /> },
  {
    rowText: (item) =>
      <EditableTableInputRow
        handleBlur={(value) => changeBatchName(item?.id, value)}
        text={item?.name} content={item?.name}
      />,
    padding: '0px',
  },
  { rowText: (item) => <DateRow date={item?.payoutDate} /> },
  { rowText: (item) => <PriceRow info={item?.amount} /> },
  // {
  //   rowText: (item) =>
  //     <div className='flex-align-center' style={{ gap: 8 }}>
  //       <button
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           handleUnPay(item);
  //         }
  //         }
  //         className='reset-btn align-justify-center'
  //         style={{
  //           textTransform: 'capitalize',
  //           width: 72,
  //           color: '#D43040',
  //           borderRadius: '4px',
  //           fontSize: '14px',
  //           fontWeight: '600',
  //           padding: '8px 14px',
  //           border: '1px solid #E3757F',
  //           boxShadow: '0 1px 2px 0px rgba(10, 13, 18, 0.05)',
  //         }}
  //       >
  //         Unpay
  //       </button>
  //     </div>,
  // },
];

export const paidPayableBatchesDetailsHead = () => [
  { name: 'displayId', nameRow: '', title: 'Load ID', custom: false },
  { name: 'carrier', nameRow: 'name', title: 'Vendor', custom: false },
  { name: 'payable', nameRow: 'payeeName', title: 'Payee', custom: false },
  {
    name: '', nameRow: 'pmtMethod', title: 'Method', custom: false,
  },
  {
    name: '', nameRow: 'pmtTerm', title: 'Term', custom: false,
  },
  {
    name: '', title: 'Aging', custom: false,
  },
  { name: '', nameRow: 'invoiceDate', title: 'Invoice Date', custom: false, type: 'date' },
  { name: '', nameRow: 'dueDate', title: 'Due Date', custom: false, type: 'date' },
  { name: '', title: 'Final Amount', icon: 'date', smallSize: 6, type: 'date', custom: false },
];

export const paidPayableBatchesDetailsBody = () => [
  {
    rowText: (item) => <div>{item?.displayId}</div>,
  },
  {
    rowText: (item) => <HyperLinkRow
      name={item?.carrier?.name}
      href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
      checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
    />,
  },
  { rowText: (item) => <TextRow name={item?.payable?.payeeName} textWidth={12} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtMethod ? item?.payable?.pmtMethod : ''} /> },
  { rowText: (item) => <TypeRow text={item?.payable?.pmtTerm ? item?.payable?.pmtTerm : ''} /> },
  { rowText: (item) => <div>{handleGetAgingDate(item?.payable?.verifiedDate)}</div>, type: 'returnColor' },
  { rowText: (item) => <DateRow date={item?.bill?.lastInvoiceDate} /> },
  { rowText: (item) => <DateRow date={item?.payable?.dueDate} /> },
  { rowText: (item) => <PriceRow info={LoadService.getPayableBalance(item?.payable)} /> },
];

export const ACTION_TYPE = 'GET_LOADS_BY_STATUS';
export const ACTION_TYPE_CREATE_BATCH = 'CREATE_LOADS_BATCH';
export const ACTION_TYPE_DELETE_BATCH = 'DELETE_LOADS_PAYABLE_BATCHES';
export const ACTION_TYPE_MOVE_BATCH = 'MOVE_LOADS_PAYABLE_BATCHES';
export const ACTION_TYPE_REMOVE_BATCH = 'REMOVE_LOADS_PAYABLE_BATCHES';
export const ACTION_TYPE_GET_BATCHES = 'GET_BATCHES';
export const ACTION_TYPE_EDIT_BATCH_TABLE = 'EDIT_BATCH_TABLE';

export const CHANGE_BATCH_STATUS_APPROVE = 'CHANGE_BATCH_STATUS_APPROVE';
export const CHANGE_BATCH_STATUS_UNPAID = 'CHANGE_BATCH_STATUS_UNPAID';

export const ACTION_TYPE_PAY_CARRIER_PAYMENT_BATCH = 'PAY_CARRIER_PAYMENT_BATCH';
export const ACTION_TYPE_UN_PAY_CARRIER_PAYMENT_BATCH = 'UN_PAY_CARRIER_PAYMENT_BATCH';

export const ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS = 'GET_LOADS_PAYABLE_BATCHES';
export const PAYABLE = 'PAYABLE';
export const SEND_CORRECTION = 'SEND_CORRECTION';

export const payableCsv = {
  type: 'payable',
  statusEnum: 'department',
};